var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHourglass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 26,
    viewBox: "0 0 19 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0938 2.46875H18.2891C18.582 2.46875 18.875 2.22461 18.875 1.88281V0.710938C18.875 0.417969 18.582 0.125 18.2891 0.125H0.710938C0.369141 0.125 0.125 0.417969 0.125 0.710938V1.88281C0.125 2.22461 0.369141 2.46875 0.710938 2.46875H0.90625C0.90625 6.42383 2.46875 10.5742 5.64258 12.625C2.41992 14.7246 0.90625 18.875 0.90625 22.7812H0.710938C0.369141 22.7812 0.125 23.0742 0.125 23.3672V24.5391C0.125 24.8809 0.369141 25.125 0.710938 25.125H18.2891C18.582 25.125 18.875 24.8809 18.875 24.5391V23.3672C18.875 23.0742 18.582 22.7812 18.2891 22.7812H18.0938C18.0938 18.875 16.4824 14.7246 13.3086 12.625C16.5312 10.5742 18.0938 6.42383 18.0938 2.46875ZM15.75 2.46875C15.75 3.88477 15.5059 5.20312 15.1152 6.375H3.83594C3.44531 5.20312 3.25 3.88477 3.25 2.46875H15.75ZM15.1152 18.875H3.83594C4.86133 15.8965 7.00977 13.7969 9.5 13.7969C11.9414 13.7969 14.0898 15.8965 15.1152 18.875Z",
    fill: "#42E483"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.ce43c4e1.svg";
export { ForwardRef as ReactComponent };